import "./css/styles.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaShip, FaUsers } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import React, {Component} from "react";
import ReactPlayer from 'react-player';
import Countdown from 'react-countdown-now';
import { Link } from 'react-router-dom';
import moment from 'moment';
import TelevisionBreakpoint from "../../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../../components/responsive_utilities/phone_breakpoint";
import { SponsorsScroller} from "../../../components/SponsorsScroller";
import { SponsorsScrollerTv} from "../../../components/SponsorsScrollerTv";
import { SancoHeader } from "../../../components/SancoHeader";
import { AnglerScores} from "./comps/AnglerScores";
import { TournamentNumsPhone} from "./comps/TournamentNumsPhone";
import { TournamentNumsTv} from "./comps/TournamentNumsTv";
import { TournamentNums} from "./comps/TournamentNums";
import { TournamentDetails} from "./comps/TournamentDetails";
import { TournamentDetailsTv} from "./comps/TournamentDetailsTv";
import { TournamentDetailsPhone} from "./comps/TournamentDetailsPhone";
import { Scroller } from "./comps/Scroller";
import { ScrollerTv } from "./comps/ScrollerTv";
import { ScrollerMobileVert } from "./comps/ScrollerMobileVert";
import { SpeciesScoresColTv } from "./comps/SpeciesScoresColTv";
import { SpeciesScoresColPhone } from "./comps/SpeciesScoresColPhone";
import { SpeciesScoresBiggest} from "./comps/speciesScoresBiggest";
import { SpeciesScoresCol } from "./comps/SpeciesScoresCol";
import { SpeciesScoresColVert } from "./comps/SpeciesScoresColVert";
import { Hookups } from "./comps/Hookups";
import { HookupsTv } from "./comps/HookupsTv";
import { HookupsPhone } from "./comps/HookupsPhone";
import { Logs } from "./comps/Logs";
import { LogsTv } from "./comps/LogsTv";
import { LogsPhone } from "./comps/LogsPhone";

import { TideChart } from "../../../components/TideChart";
import { TideChartPhone } from "../../../components/CompsPhone/TideChartPhone";
var Sound = require('react-sound').default; 

const sancoLogo = require('../../../media/sanco-logo-black.png');

const dragSound = require('../../../media/drag.wav');

const sponsorLogos = ['https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/san_lucas_logo.jpg?alt=media&token=719e7470-5f5a-4e91-8aed-8e8f0ce54d7b','https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FbajaCantina.png?alt=media&token=5dbd240f-2ff5-4c87-9f0d-5833ebb81751','https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/Mariacorona.png?alt=media&token=19e38174-2091-4448-90c8-d94f3f8c456e','https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Figy.png?alt=media&token=6698be37-5bcd-423f-92de-766ca6813c25','https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fpelagic.png?alt=media&token=2311e559-7777-42bd-a9b2-548983399086', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/PelagicPolarized.png?alt=media&token=ec0a937a-6dcb-4377-92ab-e61cbb5b34cb'];

var firebase = require('firebase/app');
require('firebase/database');

class Ptc extends Component {
  
  constructor() {
    super();
    this.state = {
      tournament: [],
      tourDay1: '',
      tourDay2: '',
      tourDay3: '',
      tourDay4: '',
      countDownDate: '',
      buttonStatus: 'current',
      buttonStatus1: 'notCurrent',
      buttonStatus2: 'notCurrent',
      buttonStatus3: 'notCurrent',
      buttonStatus4: 'notCurrent',
      tournamentLogo: '',
      tournamentName: '',
      boats: [],
			teamNums: '',
      anglersRaw: {},
			anglerNums: '',
      species: [],
      speciesRaw: {},
      boatsRaw: {},
      currentLogs: {},
      currentBoatScores: [],
      logs: [],
      fishLogs: [],
      fishLogsOne: [],
      fishLogsTwo: [],
      fishLogsThree: [],
      fishLogsFour: [],
      hookups: [],
      hps: [],
      boatLogs: [],
      boatTotals: [],
      boatTotalsOne: [],
      boatTotalsTwo: [],
      boatTotalsThree: [],
      boatTotalsFour: [],
      boatScores: [],
      boatScoresOne: [],
      boatScoresTwo: [],
      boatScoresThree: [],
      boatScoresFour: [],
      boatScoresArray: [],
      showAll: true,
      showDay1: false,
      showDay2: false,
      showDay3: false,
      showDay4: false,
      newLog: false,
      newItem: false,
      playing: 'STOPPED',
      vidPlaying: true,
      loading: true,
      newFishLog: [],
      vidLogs: [],
      vidList: [],
      currentVideo: '',
      boardId: '',
      boardName: '',
      videoVis: 'visible',
      displayVis: 'inline',
      loadingVis: 'none',
      loadingVis2: 'inline',
      speciesPoints: [],
      boatFishLogs: [],
      tourDay: '',
      currentTourDay: '',
			currentDayState: 'All'
    };
    this.baseRef = firebase.database().ref('/');
    this.ref = firebase.database().ref('tournaments');
    this.tourRef = firebase.database().ref('tournaments/-LeqU-nKI1yKi4oD8S6D');
    this.handleButtonPress = this.handleButtonPress.bind(this)
    this.handleButtonRelease = this.handleButtonRelease.bind(this)
  }
  
  componentWillMount() {
    this.tourRef.on('value', this.handleTournamentUpdate); 
    this.tourRef.child('fishLogs').on('child_added', this.handleFishLogAdded);
    this.tourRef.child('fishLogs').on('child_changed', this.handleFishLogChanged);
    this.baseRef.child('refresh').on('child_changed', this.reloadPage);
		this.baseRef.child('refreshPlaylist').on('child_changed', this.reloadPlaylist);
		this.fetchVideosList();
		var fetchVids = setInterval(
			function() {
					this.fetchVideosList();
			}
			.bind(this),
			900000
		);
  }
  
  componentDidMount() {
    window.addEventListener("keyup", this.keyHandling);
  }
    
  componentWillReceiveProps(newProps) {
    this.setState({tourDay: this.props.match.params.tourDay});
    this.getBoats();
  }
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    }
  }
  
  reloadPage = () => {
    window.location.reload(true);
  }
	
	reloadPlaylist = () => {
    this.fetchVideosList();
  }
  
  handleTournamentUpdate = (snapshot) => { 
    if(snapshot.val().fishLogs) {
      var fishLogsArray = Object.entries(snapshot.val().fishLogs);
    }
    var fishLogsList = [];
    var hookupsList = [];
    var speciesArray = Object.entries(snapshot.val().species);
    var speciesList = [];
    var boatsArray = Object.entries(snapshot.val().boats);
    var boatsList = [];
    if(snapshot.val().videos) {
        var tourVideos = Object.entries(snapshot.val().videos);
    }
      
    if(fishLogsArray) {
      fishLogsArray.forEach((log) => {
        fishLogsList.push({
          id: log[0],
          boatId: log[1].boatId,
          boatName: log[1].boatName,
					teamName: log[1].name,
          boatThm: log[1].photoUrl,
          speciesId: log[1].speciesId,
          speciesName: log[1].speciesName,
          anglerId: log[1].anglerId,
          anglerName: log[1].anglerName,
          lbs: log[1].fishLbs,
          hookedupDate: log[1].hookedupDate,
          catchDate: log[1].catchDate,
          clipUrl: log[1].clipUrl,
          status: log[1].status
        });
        if (log[1].status === 'hooked up'){
          hookupsList.push ({
            id: log[0],
            boatId: log[1].boatId,
            boatName: log[1].boatName,
						teamName: log[1].name,
            boatThm: log[1].photoUrl,
            speciesId: log[1].speciesId,
            speciesName: log[1].speciesName,
            anglerId: log[1].anglerId,
            anglerName: log[1].anglerName,
            lbs: log[1].fishLbs,
            hookedupDate: log[1].hookedupDate,
            status: log[1].status
          })
        }
      })
    }
    
    var countDownDate = moment(new Date(snapshot.val().day1Date)).format('LLL');
    var tournament = {
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
			tournamentTimeZone: snapshot.val().timeZone,
      venue: snapshot.val().venue,
      captMeetingTime: snapshot.val().captMeetingTime,
      captMeetingLoc: snapshot.val().captMeetingLoc,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      anglersRaw: snapshot.val().anglers,
      boatsRaw: snapshot.val().boats,
    }
    
    this.setState({
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
			tournamentTimeZone: snapshot.val().timeZone,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      species: speciesList, 
      speciesRaw: snapshot.val().species,
      anglersRaw: snapshot.val().anglers,
			anglerNums: Object.keys(snapshot.val().anglers).length,
      boatsRaw: snapshot.val().boats,
			teamNums: Object.keys(snapshot.val().boats).length,
      boats: boatsList,
      hps: hookupsList,
      newItem: true,
      fishLogs: this.sortFishLogs(fishLogsList),
      countDownDate,
      tournament
    });
      
    speciesArray.forEach((specie) => {
      speciesList.push({
        id: specie[0],
        name: specie[1].name,
        points: specie[1].points,
        scoreType: specie[1].scoreType,
        speciesImageUri: specie[1].speciesImageUri
      })
    })
    
    boatsArray.forEach((boat) => {
      boatsList.push({
        id: boat[0],
        name: boat[1].name,
				teamName: boat[1].name,
				boatName: boat[1].boatName,
        class: boat[1].boatClass,
        photoURL: boat[1].photoUrl,
      })
    })
    this.getBoats();
  }
  
  isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
  }

  filterDailyLogs(day, logs){
      var theDay = day.substring(0,10);
      var fishLogs =  logs.filter(function(log) {
        return log.catchDate.substring(0,10) == theDay;
      });
      var sortedLogs = this.sortFishLogs(fishLogs)
      return sortedLogs
  }
  
  
  sortFishLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    return logs
  }
  
  handleFishLogAdded = (snapshot) => {
    if (!this.state.newItem) return;
    var fishLogs = this.state.fishLogs;
    var vidLogs = this.state.vidLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDate) {
      var hd = this.formatDate(snapshot.val().hookedupDate);
    } else {
      var hd = null;
    }
      fishLogs.unshift({
        id: snapshot.key,
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
				teamName: snapshot.val().name,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        lbs: snapshot.val().fishLbs,
        anglerId: snapshot.val().anglerId,
        anglerName: snapshot.val().anglerName,
        photoUrl: snapshot.val().photoUrl,
        status: snapshot.val().status,
        hookedupDate: hd,
        catchDate: cd,
        });
      this.setState({
        vidLogs,
        newLog: true,
        vidPlaying: false,
        displayVis: 'none',
        newFishLog: {
          boatId: snapshot.val().boatId,
          boatName: snapshot.val().boatName,
					teamName: snapshot.val().name,
          photoUrl: snapshot.val().photoUrl,
          anglerName: snapshot.val().anglerName,
          anglerId: snapshot.val().anglerId,
          speciesId: snapshot.val().speciesId,
          speciesName: snapshot.val().speciesName,
          fishLbs: snapshot.val().fishLbs,
          status: snapshot.val().status,
          hookedupDate: hd,
          catchDate: cd,
        }
      })
    setTimeout(function() { this.setState({newLog: false}); }.bind(this), 10000);
    setTimeout(function() { this.setState({displayVis: 'inline'}); }.bind(this), 10000);
    setTimeout(function() { this.setState({vidPlaying: true}); }.bind(this), 10500);
  }
  
  sortLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    this.getBoats();
  }
  
  handleFishLogChanged = (snapshot, last) => {
    var logs = this.state.fishLogs;
    var vidLogs = this.state.vidLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDateDate) {
      var hd = this.formatDate(snapshot.val().hookedupDateDate);
    } else {
      var hd = null;
    }
    vidLogs.push({
      id: snapshot.key,
      boatId: snapshot.val().boatId,
      boatName: snapshot.val().boatName,
      speciesId: snapshot.val().speciesId,
      speciesName: snapshot.val().speciesName,
      lbs: snapshot.val().fishLbs,
      anglerId: snapshot.val().anglerId,
      anglerName: snapshot.val().anglerName,
      catchDate: this.formatDate(snapshot.val().catchDate),
      clipUrl: snapshot.val().clipUrl,
      status: snapshot.val().status
    })
    logs.map(log => {
      if(log.id === snapshot.key) {
        log.lbs = snapshot.val().fishLbs;
        log.boatId = snapshot.val().boatId;
        log.boatName = snapshot.val().boatName;
        log.speciesId = snapshot.val().speciesId;
        log.speciesName = snapshot.val().speciesName;
        log.anglerId = snapshot.val().anglerId;
        log.anglerName = snapshot.val().anglerName;
        log.catchDate = this.formatDate(snapshot.val().catchDate);
        log.clipUrl = snapshot.val().clipUrl;
        log.status = snapshot.val().status;
      }
    });
    this.setState({
      vidLogs,
      fishLogs:logs,
      newLog: true,
      vidPlaying: false,
      videoVis: 'hidden',
      displayVis: 'none',
      newFishLog: {
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
				teamName: snapshot.val().name,
        photoUrl: snapshot.val().photoUrl,
        anglerName: snapshot.val().anglerName,
        anglerId: snapshot.val().anglerId,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        fishLbs: snapshot.val().fishLbs,
        status: snapshot.val().status,
        hookedupDateDate: hd,
        catchDate: cd,
        }
    })
    this.getBoats();
    setTimeout(function() { this.setState({newLog: false}) }.bind(this), 10000);
    setTimeout(function() { this.setState({displayVis: 'inline'}) }.bind(this), 10000);
    setTimeout(function() { this.setState({vidPlaying: true}); }.bind(this), 10500);
  }
	
	fetchVideosList() {
		const API = 'AIzaSyDPOAO90Hmjyg73TusAFE4-OfbaDIkfkwU'
		const channelID = 'PLBE2HTUQ9kZv76ggJm5izUCptF9DT8-1y'
		const results = 20;
		var vidList = [];
		
		var finalURL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${channelID}&maxResults=${results}&key=${API}`;
		
		fetch(finalURL)
      .then((response) => response.json())
      .then((resp) => { 
				resp.items.forEach((item) => {
					vidList.push({
						url: 'https://youtu.be/' + item.snippet.resourceId.videoId,
						title: item.snippet.title,
						desc: item.snippet.description
					})
				})
				this.setState({
					vidList,
					currentVideo: vidList[0],
				})
      })
      .catch((error) => {
        console.error(error);
      });
	}
  
  getBoats() {
    var logs = this.state.fishLogs;
    var boats = this.state.boats;
    var boatLogs = [];
    var boatLogsOne = [];
    var boatLogsTwo = [];
    var boatLogsThree = [];
    var boatLogsFour = [];
    boats.forEach((boat) => {
      var boatFish = [];
      var boatFishOne = [];
      var boatFishTwo = [];
      var boatFishThree = [];
      var boatFishFour = [];
      
      //Get FishLog for each Boat
      logs.forEach((fishLog) => {
        if(!fishLog.catchDate){
          return
        }
        if(boat.id === fishLog.boatId){
          if(fishLog.length !== 0) {
            boatFish.push(fishLog);
          }
        }
        if(this.state.tourDay1.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishOne.push(fishLog);
            }
          }
        } else if(this.state.tourDay2.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishTwo.push(fishLog);
            }
          }
          
        } else if(this.state.tourDay3.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishThree.push(fishLog);
            }
          }
        } else if(this.state.tourDay4.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishFour.push(fishLog);
            }
          }
        }
      });
      if(boatFish.length !== 0) {
        boatFish.sort(function(a, b) {
            var dateA = new Date(a.catchDate), dateB = new Date(b.catchDate);
            return dateA - dateB;
        });
        var lastFishInt = (boatFish.length - 1);
        var lastFishTime = boatFish[lastFishInt].catchDate;
				var teamName = boatFish[0].teamName;
        boatLogs.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFish,
          lastFishTime:  lastFishTime
        });
      }
      if(boatFishOne.length !== 0) {
        var lastFishIntOne = (boatFishOne.length - 1);
        var lastFishTimeOne = boatFishOne[lastFishIntOne].catchDate;
				var teamName = boatFishOne[0].teamName;
        boatLogsOne.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishOne,
          lastFishTime:  lastFishTimeOne
        });
      } 
      
      if(boatFishTwo.length !== 0) {
        var lastFishIntTwo = (boatFishTwo.length - 1);
        var lastFishTimeTwo = boatFishTwo[lastFishIntTwo].catchDate;
				var teamName = boatFishTwo[0].teamName;
        boatLogsTwo.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishTwo,
          lastFishTime:  lastFishTimeTwo
        });
      }
      if(boatFishThree.length !== 0) {
        var lastFishIntThree = (boatFishThree.length - 1);
        var lastFishTimeThree = boatFishThree[lastFishIntThree].catchDate;
				var teamName = boatFishThree[0].teamName;
        boatLogsThree.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishThree,
          lastFishTime:  lastFishTimeThree
        });
      }
      
      if(boatFishFour.length !== 0) {
        var lastFishIntFour = (boatFishFour.length - 1);
        if(lastFishIntFour) {
          var lastFishTimeFour = boatFishFour[lastFishIntFour].catchDate;
					var teamName = boatFishFour[0].teamName;
          boatLogsFour.push({
            boatId: boat.id,
            boatName: boat.boatName,
						teamName,
            boatClass: boat.class,
            boatThm: boat.photoURL,
            boatCaughtFish: boatFishFour,
            lastFishTime: lastFishTimeFour
          });
        }
      }
    });
    var bTotals = this.getBoatTotals(boatLogs);
    var bTotalsOne = this.getBoatTotals(boatLogsOne);
    var bTotalsTwo = this.getBoatTotals(boatLogsTwo);
    var bTotalsThree = this.getBoatTotals(boatLogsThree);
    var bTotalsFour = this.getBoatTotals(boatLogsFour);
    this.setState({
      logs: boatLogs,
      currentLogs: boatLogs,
      fishLogsOne: boatLogsOne,
      fishLogsTwo: boatLogsTwo,
      fishLogsThree: boatLogsThree,
      fishLogsFour: boatLogsFour,
      currentBoatScores: this.scoreSortFilter(bTotals),
      boatScores: this.scoreSortFilter(bTotals),
      boatScoresOne: this.scoreSortFilter(bTotalsOne),
      boatScoresTwo: this.scoreSortFilter(bTotalsTwo),
      boatScoresThree: this.scoreSortFilter(bTotalsThree),
      boatScoresFour: this.scoreSortFilter(bTotalsFour),
    })
    setTimeout(this.toggleLoading, 3000)
  }

  toggleLoading = () => {
    this.setState({
        loading: false,
        loadingVis: 'inline',
        loadingVis2: 'none',
      });
  }

  getBoatTotals(bLogs) {
    var boatTotals = [];
    bLogs.forEach((boatLog) => {
      var logs = boatLog.boatCaughtFish;
      var sps = this.state.species;
      var boatCounts = [];
      var boatPoints = [];
      var boatLbsPoints = [];
      var boatTotal = '';
      
      sps.forEach((specie) => {
        var speciesId = specie.id
        var speciesName = specie.name;
        var speciesPoints = specie.points;
        var scoreType = specie.scoreType;
        var speciesCount = [];
        var speciesTimes = [];
        var speciesScores = 0;
         
        if (scoreType === 'QTY'){
          logs.forEach((log) => {
           
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
              speciesTimes.push(log.catchDate);
            }
          }); 
            
          var count = speciesCount.length;
          var points = parseFloat(count * speciesPoints);
          var totalPoints = (points + speciesScores)
          boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
						teamName: boatLog.teamName,
            boatThm: boatLog.boatThm,
            boatClass: boatLog.boatClass,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints: totalPoints,
            speciesTimes: speciesTimes
          });
          boatPoints.push(totalPoints);
        }
        if (scoreType === 'LBS'){
          logs.forEach((log) => {
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
              speciesPoints = speciesPoints * log.lbs;
            }
          });
          if(speciesCount.length > 0) {
            boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
						teamName: boatLog.teamName,
            boatThm: boatLog.boatThm,
            boatClass: boatLog.boatClass,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints,
          });
          }
          boatLbsPoints.push(totalPoints);
        }
      });
      boatTotal = boatPoints.reduce(function(sum, value) {
        return sum + value;
      }, 0);
      boatTotals.push({
        id: boatLog.boatId,
        boatName: boatLog.boatName,
				teamName: boatLog.teamName,
        boatClass: boatLog.boatClass,
        boatThm: boatLog.boatThm,
        speciesCounts: boatCounts,
        total: boatTotal,
        lastFishTime: this.formatDate(boatLog.lastFishTime)
      })
    })
    return boatTotals
  }

  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    
    boatScores.sortOn("total", "lastFishTime");
    boatScores.reverse();
    
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })
    return bScores;  
  }

  formatDate(date) {
    var options = {
      month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric',
      hour12: true,
      timeZone: 'America/Mazatlan',
    };
    var newDate = new Date(date);
    var formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);
    return formattedDate;
  }

  catchDate(date) {
    var catchDate = new Date(date)
    var hour = catchDate.getHours();
    var secs = catchDate.getSeconds();
    var ampm = hour >= 12 ? 'PM' : 'AM';
    var minutes = catchDate.getMinutes();
    hour = hour % 12;
    hour = hour ? hour : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var dateString = hour + ':' + minutes + ':' + secs + '' + ampm;
    
    return dateString
  }

  nextVideo(currentVideo) {
    const videos = this.state.vidList;
    var i = videos.length - 1;
    var index = videos.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videos[next]
    })
  }

  buffering(currentVid) {
      console.log('BUFFERING')
      setInterval(this.nextVideo(currentVid), 10000)
  }

  handleButtonPress (event) {
      var day = event.target.id;
      if(day === "All"){
          var currentLogs = this.state.fishLogs;
          var currentBoatScores = this.state.boatScores;
      } else if (day === "Day1") {
          var currentLogs = this.state.fishLogsOne;
          var currentBoatScores = this.state.boatScoresOne;
      } else if (day === "Day2") {
          var currentLogs = this.state.fishLogsTwo;
          var currentBoatScores = this.state.boatScoresTwo;
      }
    this.setState({
        currentLogs,
        currentBoatScores
    })
    event.preventDefault();
  }

  handleButtonRelease (event) {
    var day = event.target.id;
      if(day === "All"){
          var currentLogs = this.state.logs;
          var currentBoatScores = this.state.boatScores;
      } else if (day === "Day1") {
          var currentLogs = this.state.fishLogsOne;
          var currentBoatScores = this.state.boatScoresOne;
      } else if (day === "Day2") {
          var currentLogs = this.state.fishLogsTwo;
          var currentBoatScores = this.state.boatScoresTwo;
      }
    this.setState({
        currentLogs,
        currentBoatScores,
				currentDayState: day
    })
    event.preventDefault();
  }
  render () {
    if(this.state.newFishLog.photoUrl) {
        var imageUrl = this.state.newFishLog.photoUrl;
      } else {
        var imageUrl = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';
      }
    if(this.state.newLog) {
      var popBox = 
          <div className="popContainer">
              <div
                id="boatContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  flex: 1,
                  minHeight: '400px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBox">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBox">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '80px',
                        height: '40px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainer">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerName">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBox">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div> 
                  </div> 
                  { this.state.newFishLog.fishLbs > 0 ? <div className="fishLbs">
                      {this.state.newFishLog.fishLbs} LBS.
                    </div> : null }
               </div>
            </div>
    } else {
      var popBox = null;
    }

    if(this.state.newLog) {
      var popMobileBox = 
          <div className="popContainer">
              <div
                id="boatMobileContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  Height: '250px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBoxMobile">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBoxMobile">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '80px',
                        height: '40px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainerMobile">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerNameMobile">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBoxMobile">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div>
                  </div> 
                    { this.state.newFishLog.fishLbs ? <div className="fishLbsPhone">
                      {this.state.newFishLog.fishLbs}
                    </div> : null }
               </div>
            </div>
    } else {
      var popMobileBox = null;
    }
    
    if(this.state.newLog) {
      var popBoxTv = 
          <div className="popContainer">
              <div
                id="boatTVContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  Height: '630px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="pelDetailsBoxTv">
                    <div className="pelCaughtBoxTv">
                        {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </div>
                    <div className="pelDetailsRow">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '200px',
                        height: '100px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>

                    <div className="anglerDetailRowTv">
                        <div className="anglerNameTv">
                          {this.state.newFishLog.anglerName}
                        </div>
                        <div className="dateBoxTv">
                          {this.catchDate(this.state.newFishLog.catchDate)}
                        </div>
                    </div>

                  </div> 
                    <div className="boatNameContainerTv">
                      {this.state.newFishLog.boatName}
                    </div>
                    { this.state.newFishLog.fishLbs > 0 ? <div className="fishLbsTv">
                      {this.state.newFishLog.fishLbs} LBS
                    </div> : null }
                    </div>
               </div>
            </div>
    } else {
      var popBoxTv = null;
    }
    return (
      <div className="main-container">
          <TelevisionBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis, padding: '5%'}}>
              <div className="scroller_rowTv" style={{
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 0%',
                backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/speciesFlags%2FbaitBall.jpg?alt=media&token=00f17f39-0f5a-4c35-aba0-1ab99dd0d41c)'
              }}>
                  {this.state.boatScores.length > 0 ? 
									 <div className="headerRow">
                    <div className="headerBoxFull">
											 <div className='pesc_tourLogoTv' 
												style={{
													backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
												}} />
                      <div className="scoreRowTv">
                        <Scroller boatScores={this.state.boatScores} boatClass='General' />
                      </div>
                    </div>
										</div>: 
                    <div className="headerBox"><div style={{height: 170, flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <div className='pesc_tourLogoTv' 
                      style={{
                        backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
                      }} />
                    </div>
                  </div>
                  }
                  
                  {this.state.boatScores.length > 0 ? 
                    null : 
                    <div className="headerBox3"><div style={{marginRight: 30, marginTop: 20, height: 150, flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <div className="countBox">
                      <center>
                      <div className="countdownTitleTv">Countdown to Lines In</div>
                      <Countdown 
                        date={this.state.countDownDate}
                        renderer={props => 
                          <div className="countDownRow">
                            <div className="countDownBoxTv">{props.days} <br />Days</div>
                            <div className="countDownBoxTv">{props.hours}<br />Hrs</div>
                            <div className="countDownBoxTv">{props.minutes}<br />Mins</div>
                            <div className="countDownBoxTv">{props.seconds}<br />Secs</div>
                          </div>
                        }
                         /> 
                      </center>
                      </div>
                      </div>
                  </div>
                    }
              </div>
              <div className="row2">
                 <div className="tvColumn1">
                    <div className="logColumnTitle"> PELAGIC TRIPLE UNOFFICIAL LEADERBOARDS</div>
                   { popBoxTv }
                    <div style={{
                      display: this.state.displayVis,
                      width: '100%', 
                      justifyContent:'center', alignItems: 'center'}}>
                      <center>
                        <div className="videoContainer"> 
                          <ReactPlayer 
                            url={this.state.currentVideo.url}
                            controls={true}
                            width={'100%'}
                            height={600}
                            volume={.5}
                            muted={false}
                            playsinline={true}
                            onEnded={() => {
                              this.nextVideo(this.state.currentVideo)
                            }}
                            playing={this.state.vidPlaying}>
                          </ReactPlayer>
												</div>
                      </center>
                    </div>
                </div>
                {this.state.logs.length > 0 ? <div className="logBox">
                  <div className="logColumn">
									<div className="logColumnTitle">Species Numbers</div>
										<TournamentNumsTv anglerNums={this.state.anglersRaw} boats={this.state.boatsRaw} logs={this.state.fishLogs} species={this.state.species}/>
                    <div className='scoreRowTvSpecies'>
                        <SpeciesScoresColTv speciesId='-LewVFe3lfchYyMGxOSJ' speciesName='Dorado' logs={this.state.currentLogs} boatClass={'General'} />
                        <SpeciesScoresColTv speciesId='-LewVDVkJ-pYZvzzzpal' speciesName='Tuna' logs={this.state.currentLogs} boatClass={'General'}/>
                    </div>
										<div className='scoreRowTvSpecies'>
                        <SpeciesScoresColTv speciesId='-LewVIx2h9p9MjW7xEw-' speciesName='Wahoo' logs={this.state.currentLogs} boatClass={'General'} />
                    </div>
                    {this.isEmpty(this.state.speciesRaw) ? null : <div>
										<div className="logColumnTitle">Latest Action</div>
										<LogsTv logs={this.state.fishLogs} speciesRaw={this.state.speciesRaw} boatsRaw={this.state.boatsRaw} anglersRaw={this.state.anglersRaw}/></div>}
                  </div>
                </div> : 
                <div style={{width: '45%'}}>
                <TournamentDetailsTv tournament={this.state.tournament} />
                <TideChart tournamentId={this.state.tournamentId} />
                </div> 
                }
              </div>
                <div style={{height: '150px', backgroundColor: '#fff'}}>
                 <SponsorsScrollerTv sponsors={ sponsorLogos } slides={4}/>
                </div>
              </div>
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournamant Logo'/>
                  </div>
              </div>
            </TelevisionBreakpoint>
          <DesktopBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis}}>
              <div className="scroller_row_desk" style={{
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 0%',
                backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/speciesFlags%2FbaitBall.jpg?alt=media&token=00f17f39-0f5a-4c35-aba0-1ab99dd0d41c)'
              }}>
                  {this.state.boatScores.length > 0 ? 
                    <div className="headerBoxFull">
                      <div className="scoreRowTv">
                        <Scroller boatScores={this.state.boatScores} boatClass='General' />
                      </div>
                    </div> : 
                    <div className="headerBox3"><div style={{height: 170, flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    {this.state.tournamentLogo ? <div className='qbc_tourLogo' 
                      style={{
                        backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
                      }} /> : null}
                    </div>
                  </div>
                  }
                  
                  {this.state.boatScores.length > 0 ? null : 
                    <div className="headerBox3"><div style={{marginRight: 30, height: 150, flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <div className="countBox">
                      <center>
                      <div className="countdownTitle">Countdown to Lines In</div>
                      <Countdown 
                        date={this.state.countDownDate}
                        renderer={props => 
                          <div className="countDownRow">
                            <div className="countDownBox">{props.days} <br />Days</div>
                            <div className="countDownBox">{props.hours}<br />Hrs</div>
                            <div className="countDownBox">{props.minutes}<br />Mins</div>
                            <div className="countDownBox">{props.seconds}<br />Secs</div>
                          </div>
                        }
                         /> 
                      </center>
                      </div>
                      </div>
                  </div>
                    }
                
              </div>
              <div className="row2">
                 <div className="tvColumn1">
                    <div className="logColumnTitleDesk"> PELAGIC TRIPLE CROWN UNOFFICIAL LEADERBOARDS</div>
                   { popBox }
                    <div style={{
                      display: this.state.displayVis,
                      width: '100%', 
                      justifyContent:'center', alignItems: 'center'}}>
                      <center>
                        <div className="videoContainer"> 
                          <ReactPlayer 
                            url={this.state.currentVideo.url}
                            controls={true}
                            width={'100%'}
                            height={400}
                            volume={.5}
                            muted={true}
                            playsinline={true}
                            onEnded={() => {
                              this.nextVideo(this.state.currentVideo)
                            }}
                            playing={this.state.vidPlaying}>
                          </ReactPlayer>
                        </div>
                      </center>
                    </div>
                </div>
                {this.state.logs.length > 0 ? <div className="logBox">
                  <div className="logColumn">
										<div className="logColumnTitleDesk">Species Numbers</div>
										<TournamentNums anglerNums={this.state.anglersRaw} boats={this.state.boatsRaw} logs={this.state.fishLogs} species={this.state.species}/>
                    <div className='scoreRowTvSpecies'>
                        <SpeciesScoresColTv speciesId='-LewVFe3lfchYyMGxOSJ' speciesName='Dorado' logs={this.state.currentLogs} boatClass={'General'} />
                        <SpeciesScoresColTv speciesId='-LewVDVkJ-pYZvzzzpal' speciesName='Tuna' logs={this.state.currentLogs} boatClass={'General'}/>
                    </div>
										<div className='scoreRowTvSpecies'>
                        <SpeciesScoresColTv speciesId='-LewVIx2h9p9MjW7xEw-' speciesName='Wahoo' logs={this.state.currentLogs} boatClass={'General'} />
                    </div>
                  </div>
                </div> : 
                <div style={{width: '45%'}}>
                <TournamentDetails tournament={this.state.tournament} />
                </div> 
                }
              </div>
                <div style={{height: '100px', backgroundColor: '#fff'}}>
                 <SponsorsScroller sponsors={ sponsorLogos } slides={4}/>
                </div>
              </div>
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournamant Logo'/>
                  </div>
              </div>
							<Sound
								url={dragSound}
								playStatus={this.state.vidPlaying ? 'STOPPED' : 'PLAYING'}
              />
            </DesktopBreakpoint>
            <TabletBreakpoint>
            <div style={{display: this.state.loadingVis}}>
							<SancoHeader />
                <div className="detailsHeader" 
                    style={{backgroundColor: '#fff', paddingBottom: '10px'}}>
                      {this.state.tournamentLogo ? <div className='tourLogoHeader' 
                        style={{ backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'}} /> : null} 
                </div>
								<div className='dailyButtonRow'>
									<div className='dailyButton' 
													style={{
																 backgroundColor: this.state.currentDayState === 'All' ? '#5A8AB2' : '#ddd'
																}}
															id={'All'} 
										onTouchStart={this.handleButtonPress.bind(this)} 
											onTouchEnd={this.handleButtonRelease} 
										 onMouseDown={this.handleButtonPress} 
											 onMouseUp={this.handleButtonRelease}>
												 All
									</div>
									<div className='dailyButton' 
													style={{
																 backgroundColor: this.state.currentDayState === 'Day1' ? '#5A8AB2' : '#ddd'
																}}
															id={'Day1'} 
										onTouchStart={this.handleButtonPress.bind(this)} 
											onTouchEnd={this.handleButtonRelease} 
										 onMouseDown={this.handleButtonPress} 
											 onMouseUp={this.handleButtonRelease}>
												 Day 1
									</div>
									<div className='dailyButton' 
													style={{
																 backgroundColor: this.state.currentDayState === 'Day2' ? '#5A8AB2' : '#ddd'
																}}
															id={'Day2'} 
										onTouchStart={this.handleButtonPress.bind(this)} 
											onTouchEnd={this.handleButtonRelease} 
										 onMouseDown={this.handleButtonPress} 
											 onMouseUp={this.handleButtonRelease}>
												 Day 2
									</div>
								</div>
									<div className="tnp-container">
										<IconContext.Provider value={{ color: "blue" }}>
											<div className="tnp-boatBox"><FaShip size={32}/>   Boats: {this.state.teamNums}</div>
										</IconContext.Provider>
										<IconContext.Provider value={{ color: "blue" }}>
											<div className="tnp-boatBox"><FaUsers size={32}/>   Anglers: {this.state.anglerNums}</div>
										</IconContext.Provider>
									</div>
									<div className="tnp-speciesNum-container">
										<TournamentNumsPhone anglerNums={this.state.anglersRaw} boats={this.state.boatsRaw} logs={this.state.fishLogs} species={this.state.species}/>
									</div>
									<div className="tvColumn">
                    { popMobileBox }
                  </div>
									<div className="division_title_phone">Hooked Up Now</div>
											{this.isEmpty(this.state.speciesRaw) ? null : <HookupsPhone slidesToShow={1} hookups={this.state.hookups} logs={this.state.fishLogs} speciesRaw={this.state.speciesRaw} boatsRaw={this.state.boatsRaw} anglersRaw={this.state.anglersRaw}/> }
											<div className="division_title_phone">Latest Action</div>
											{this.isEmpty(this.state.speciesRaw) ? null : <LogsPhone slidesToShow={1} hookups={this.state.hookups} logs={this.state.fishLogs} speciesRaw={this.state.speciesRaw} boatsRaw={this.state.boatsRaw} anglersRaw={this.state.anglersRaw}/> }
									<div style={{height: '100px', backgroundColor: '#fff', marginTop: '10px'}}>
                    <SponsorsScroller sponsors={ sponsorLogos } slides={3}/>
                  </div>
									<div className="catBox">
										<div className="division_title_phone">Big Boat Division</div>
										<Scroller boatScores={this.state.currentBoatScores} boatClass={'Big Boat'}/>
									</div>
									<div className="catBox">
										<div className="division_title_phone">Small Boat Division</div>
										<Scroller boatScores={this.state.currentBoatScores} boatClass={'Small Boat'}/>
									</div>
									<div>
										<div className="catBox">
											<SpeciesScoresColPhone speciesId='-LZe8Jyy23ZZT9b_dnf_' speciesName='Dorado' logs={this.state.currentLogs} boatClass={'Big Boat'} />
										</div>
										<div className="catBox">
											<SpeciesScoresColPhone speciesId='-LZe8NIHDE4YgCgLZ3YB' speciesName='Tuna' logs={this.state.currentLogs} boatClass={'Big Boat'}/>
										</div>
										<div>
										<div className="catBox">
											<AnglerScores species={this.state.speciesRaw} logs={this.state.currentLogs} anglers={this.state.anglersRaw} boatClass={'General'}/>
										</div>
									</div>
									</div>
                  {this.state.boatScores.length > 0 ? null : 
                    <div style={{flex: 1, height: '140px', marginBottom: '5px'}}>
                    <div className="countBox">
                      <center>
                        <div className="countdownTitlePhone">Countdown to Lines In</div>
                          <Countdown 
                            date={this.state.countDownDate}
                            renderer={props => 
                              <div className="countDownRow">
                                <div className="countDownBox">{props.days} <br />Days</div>
                                <div className="countDownBox">{props.hours}<br />Hrs</div>
                                <div className="countDownBox">{props.minutes}<br />Mins</div>
                                <div className="countDownBox">{props.seconds}<br />Secs</div>
                              </div>
                            }
                             /> 
                        </center>
                      </div>
                    </div>
                    }
                  {this.state.fishLogs.length > 0 ? null : 
                   <div>
                    <TournamentDetailsPhone tournament={this.state.tournament} />
                      <iframe width="100%" height="250" src="https://embed.windy.com/embed2.html?zoom=4&level=surface&overlay=wind&menu=&message=true&marker=&calendar=&pressure=true&type=map&location=coordinates&metricWind=default&metricTemp=default&radarRange=-1" frameBorder="0"></iframe>
                  </div>
                  }
              </div>}
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournament Logo'/>
                  </div>
              </div>
							<Sound
								url={dragSound}
								playStatus={this.state.vidPlaying ? 'STOPPED' : 'PLAYING'}
              />
            </TabletBreakpoint>
            <PhoneBreakpoint>
            <div style={{display: this.state.loadingVis}}>
                <div className="detailsHeaderQbc" 
                    style={{marginTop: '10px'}}>
                      {this.state.tournamentLogo ? <div className='tourLogoHeader' 
                        style={{ backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'}} /> : null} 
                </div>
								<a href="https://site.sancochero.com/quepos-billfish-cup-video-submitter/">
									<div className='vidSubmitButton'>
										Video Submitter
									</div>
								</a>
								
								<div className="tour-details-container">
									{this.state.boatScores.length > 0 ? <div className="tnp-container">
										<IconContext.Provider value={{ color: "blue" }}>
											<div className="tnp-boatBox"><FaShip size={32}/>   Boats: {this.state.teamNums}</div>
										</IconContext.Provider>
										<IconContext.Provider value={{ color: "blue" }}>
											<div className="tnp-boatBox"><FaUsers size={32}/>   Anglers: {this.state.anglerNums}</div>
										</IconContext.Provider>
									</div> : null }
									<TournamentNumsPhone anglerNums={this.state.anglersRaw} boats={this.state.boatsRaw} logs={this.state.fishLogs} species={this.state.species}/>
									<div className="tvColumn">
                    { popMobileBox }
										<div style={{
                      display: this.state.displayVis,
                      width: '100%', 
                      justifyContent:'center', alignItems: 'center'}}>
                      <center>
                        <div className="videoContainer"> 
                          <ReactPlayer 
                            url={this.state.currentVideo.url}
                            controls={true}
                            width={'100%'}
                            height={250}
                            volume={.5}
                            muted={true}
                            playsinline={true}
                            onEnded={() => {
                              this.nextVideo(this.state.currentVideo)
                            }}
                            playing={this.state.vidPlaying}>
                          </ReactPlayer>
                        </div>
                      </center>
                    </div>
                  </div>
									</div>
									<div style={{height: '100px', backgroundColor: '#fff', marginTop: '10px', marginBottom:'40px'}}>
                    <SponsorsScroller sponsors={ sponsorLogos } slides={3}/>
                  </div>
									<div className="catBox">
										<ScrollerMobileVert boatScores={this.state.currentBoatScores} boatClass={'General'}/>
									</div>
									<div>
										<div className="catBox">
											<SpeciesScoresColPhone logs={this.state.currentLogs} boatClass={'General'} speciesId='-LewVDVkJ-pYZvzzzpal' speciesName='Tuna'/>
										</div>
									</div>
									<div>
										<div className="catBox">
											<SpeciesScoresColPhone logs={this.state.currentLogs} boatClass={'General'} speciesId='-LewVFe3lfchYyMGxOSJ' speciesName='Dorado'/>
										</div>
									</div>
									<div>
										<div className="catBox">
											<SpeciesScoresColPhone logs={this.state.currentLogs} boatClass={'General'} speciesId='-LewVIx2h9p9MjW7xEw-' speciesName='Wahoo'/>
										</div>
									</div>
                  {this.state.boatScores.length > 0 ? null : 
                    <div style={{flex: 1, height: '140px', marginBottom: '5px'}}>
                    <div className="countBox">
                      <center>
                        <div className="countdownTitlePhone">Countdown to Lines In</div>
                          <Countdown 
                            date={this.state.countDownDate}
                            renderer={props => 
                              <div className="countDownRow">
                                <div className="countDownBox">{props.days} <br />Days</div>
                                <div className="countDownBox">{props.hours}<br />Hrs</div>
                                <div className="countDownBox">{props.minutes}<br />Mins</div>
                                <div className="countDownBox">{props.seconds}<br />Secs</div>
                              </div>
                            }
                             /> 
                        </center>
                      </div>
                    </div>
                    }
                  {this.state.fishLogs.length > 0 ? null : 
                   <div>
                    <TournamentDetailsPhone tournament={this.state.tournament} />
                      <iframe width="100%" height="250" src="https://embed.windy.com/embed2.html?zoom=4&level=surface&overlay=wind&menu=&message=true&marker=&calendar=&pressure=true&type=map&location=coordinates&metricWind=default&metricTemp=default&radarRange=-1" frameBorder="0"></iframe>
                  </div>
                  }
              </div>}
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournament Logo'/>
                  </div>
              </div>
							<Sound
								url={dragSound}
								playStatus={this.state.vidPlaying ? 'STOPPED' : 'PLAYING'}
              />
            </PhoneBreakpoint>
      </div> 
    );
  }
}

export default Ptc;


// WEBPACK FOOTER //
// ./src/pages/tournaments/ptc/Ptc.js